<div class="select-container" [class.is-invalid]="isInvalid">
  <select #selectElement [multiple]="multiple"></select>
  <div #contentElement class="content-element" [class.closed]="!open" [class.open]="open"></div>
</div>